import Dashboard from './Dashboard.vue';

export default { Dashboard, 'name': "documents" };
